<template>
  <div class="running-card">
    <div class="header">
      <MapActions class="action" />
      <slot name="header"></slot>
    </div>
    <div class="content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import MapActions from '@/views/home-v2/components/MapActions.vue';

export default {
  name: "RunningCard",
  components: {
    MapActions,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.running-card {
  position: relative;
  .header {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    padding-bottom: 40px;
    background: linear-gradient(180deg, #bddeff 0%, #ffffff 100%),
      linear-gradient(216deg, #d9fff3 0%, rgba(255, 255, 255, 0) 100%);
    border-radius: 28px 28px 0px 0px;
    transform: translateY(calc(-100% + 40px));
  }

  .action {
    position: absolute;
    top: 0;
    right: 0;
    transform: translateY(calc(-100% - 10px));
    margin-right: 10px;
  }

  .content {
    background: #ffffff;
    border-radius: 28px 28px 0px 0px;
    position: relative;
  }
}
</style>
